export function retornarApenasNumeros(valor) {
  if (!valor) return null;
  const listaDeNumeros = String(valor).match(/[0-9]/g);
  const resultado = listaDeNumeros.length ? listaDeNumeros.join("") : null;
  return resultado;
}
